.Block {
  background-color: var(--color-panel-background);
  color: var(--color-default);
  padding: 1rem;
  border-radius: 0.5rem;

  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.Block[data-type="demo"] {
  background-color: var(--color-demo-background);
  color: var(--color-demo);
}
